import React from "react";

import InitialFormContainer from "./InitialFormContainer";

import './InitialFormStyleSheet.css';

function InitialForm(props) {
  return (
    <div className="s360-initial-form">
      <InitialFormContainer {...props} />
    </div>
  );
}

export default InitialForm;
